


















import { Component, Prop, Vue } from "vue-property-decorator";
import NationalIdSkeleton from "@/modules/externals/components/NationalIdSkeleton.vue";
import SkeletonLoader from "@/modules/externals/components/SkeletonLoader.vue";

@Component({
  components: {
    "national-id-skeleton": NationalIdSkeleton,
    "skeleton-loader": SkeletonLoader,
  },
})
export default class Passport extends Vue {
  @Prop()
  front!: string;
  passportImageLoading = true;
  onPassportImageLoad() {
    this.passportImageLoading = false;
  }
}
